module.exports = echarts;


//////////////////
// WEBPACK FOOTER
// external "echarts"
// module id = Pg0u
// module chunks = 54